"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedCostAudienceSizeResponseToJSON = exports.FixedCostAudienceSizeResponseFromJSONTyped = exports.FixedCostAudienceSizeResponseFromJSON = exports.instanceOfFixedCostAudienceSizeResponse = void 0;
var runtime_1 = require("../runtime");
var Errors_1 = require("./Errors");
var FixedCostAudienceSizeResult_1 = require("./FixedCostAudienceSizeResult");
/**
 * Check if a given object implements the FixedCostAudienceSizeResponse interface.
 */
function instanceOfFixedCostAudienceSizeResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFixedCostAudienceSizeResponse = instanceOfFixedCostAudienceSizeResponse;
function FixedCostAudienceSizeResponseFromJSON(json) {
    return FixedCostAudienceSizeResponseFromJSONTyped(json, false);
}
exports.FixedCostAudienceSizeResponseFromJSON = FixedCostAudienceSizeResponseFromJSON;
function FixedCostAudienceSizeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !(0, runtime_1.exists)(json, 'result') ? undefined : (0, FixedCostAudienceSizeResult_1.FixedCostAudienceSizeResultFromJSON)(json['result']),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, Errors_1.ErrorsFromJSON)(json['errors']),
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
        'forecastItemId': !(0, runtime_1.exists)(json, 'forecast_item_id') ? undefined : json['forecast_item_id'],
    };
}
exports.FixedCostAudienceSizeResponseFromJSONTyped = FixedCostAudienceSizeResponseFromJSONTyped;
function FixedCostAudienceSizeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': (0, FixedCostAudienceSizeResult_1.FixedCostAudienceSizeResultToJSON)(value.result),
        'errors': (0, Errors_1.ErrorsToJSON)(value.errors),
        'salesforce_line_item_id': value.salesforceLineItemId,
        'forecast_item_id': value.forecastItemId,
    };
}
exports.FixedCostAudienceSizeResponseToJSON = FixedCostAudienceSizeResponseToJSON;
